import { dataFireSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFireSolid = /*#__PURE__*/createIcon(dataFireSolid)
export default IconFireSolid
